import { defineQuiz } from "./_schema";
import { cortisolQuiz } from "./cortisol";

/**
 * CORTISOL-QUIZ-AL -- tracking-isolated duplicate of the cortisol quiz for
 * AppLovin traffic.
 *
 * Analytics in this system is keyed by SLUG, not URL (admin funnel,
 * quiz_submissions.quiz_slug, Klaviyo event/profile props). AppLovin-sourced
 * traffic to the cortisol funnel needs to be attributable separately, so we
 * mount an identical quiz under a distinct slug and publish it at
 * /pages/cortisol-quiz-al. Same on-screen experience, separate row everywhere
 * in our own analytics. Mirrors the quiz-v6-al / quiz-v6-gl pattern.
 *
 * This is a THIN RE-EXPORT of cortisol: it spreads `cortisolQuiz` and overrides
 * only `id` / `slug`. The two quizzes share the same `questions` array,
 * `branching`, `classifier`, and `deriveProfile` (deriveCortisolProfile, with
 * its cortisol-dominance forced-Primary seam) BY REFERENCE, so they can never
 * drift -- any future edit to cortisol's content or deriver propagates here
 * automatically. If the two are ever meant to diverge, that becomes a
 * deliberate change (stop spreading, fork the fields).
 *
 * Unlike quiz-v6-al, there is no Intelligems `experiment` to drop -- the
 * cortisol quiz never carried one.
 *
 * See docs/specs/2026-07-22-applovin-tracking-duplicates-design.md.
 */
export const cortisolQuizAlQuiz = defineQuiz({
  ...cortisolQuiz,
  id: "cortisol-quiz-al",
  slug: "cortisol-quiz-al",
});
